<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)">
      <path
        d="M1 19V4h2v10h8V6h8c1.1 0 2.042.392 2.825 1.175C22.608 7.958 23 8.9 23 10v9h-2v-3H3v3H1Zm6-6a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 4 10c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 7 7c.833 0 1.542.292 2.125.875S10 9.167 10 10s-.292 1.542-.875 2.125A2.893 2.893 0 0 1 7 13Zm6 1h8v-4c0-.55-.196-1.02-.587-1.412A1.926 1.926 0 0 0 19 8h-6v6Zm-6-3c.283 0 .52-.096.713-.287A.968.968 0 0 0 8 10a.968.968 0 0 0-.287-.713A.968.968 0 0 0 7 9a.968.968 0 0 0-.713.287A.968.968 0 0 0 6 10c0 .283.096.52.287.713.192.191.43.287.713.287Z"
      />
      <path d="M22 23 0 3M24 21 2 1" stroke="#241e3d" stroke-width="2" />
      <path d="M23 22 .989 2.012" stroke="#fff" stroke-width="2" />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M0 0h24v24H0z" /></clipPath>
    </defs>
  </svg>
</template>
